import React from "react";
import {
  Button,
  Carousel,
  Col,
  Row,
  InputGroup,
  Container,
  Form,
  Card,
} from "react-bootstrap";
import Slider from "../assets/fullstack.png";
import Slider1 from "../assets/eln.jpg";
import Slider2 from "../assets/slide3.jpg";
import People from "../assets/people-group.png";
import Student from "../assets/stud.png";
import Mentors from "../assets/life.png";
import LifeTime from "../assets/webd.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Banner = () => {
  return (
    <>
      <Carousel className="slide-img">
        <Carousel.Item className="position-relative">
          <img src={Slider1} alt="Banner" className="img-fluid opacity-75" />
          <Carousel.Caption className="banner-text position-absolute  text-start">
            <h5 className="text-white">Learn without limits</h5>
            <h3 className="text-white">
              Expand your career opportunities with VK Learning
            </h3>
            <p className="text-white">
              Start, switch, or advance your career with VK Learning
            </p>
            <p className="text-white">
              Designed to transform you into a highly skilled Software
              Professional
            </p>
            <Button variant="warning" className="px-4 py-2 mb-5">
              Register now
            </Button>
          </Carousel.Caption>
        </Carousel.Item>
        {/* <Carousel.Item className="position-relative">
          <img src={Slider} alt="Banner" className="img-fluid" />
          <Carousel.Caption className="banner-text position-absolute text-start ms-5 ps-5">
            <h3 className="text-white">
              Become a Full Stack Developer with VK Learning Program
            </h3>
            <p className="text-white">
              <ul>
                <li>
                  Upskill in DSA & System Design with specialization in Full
                  Stack Development
                </li>
                <li>
                  Build real-world projects by mastering React, MERN,
                  JavaScript, etc.
                </li>
                <li>
                  Learn the essential Full Stack development concepts from
                  scratch
                </li>
              </ul>
            </p>
            <Button variant="danger" className="px-4 py-2 mb-5">
              Know More
            </Button>
          </Carousel.Caption>
        </Carousel.Item> */}
      </Carousel>
      <section className="bg-light">
        <Container className="py-4">
          <Row className="coursedet">
            <Col md={4} className="mb-2">
              <Card className="shadow feature-cd">
                <div className="d-flex align-items-center cours p-2 rounded-3">
                  {/* <div className="flex-shrink-0">
                  
                </div> */}
                  <div className="flex-grow-1 ms-2 pt-3 text-center">
                    <h1>
                      <i className="fa-solid fa-laptop-code border rounded-pill bg-hero"></i>
                    </h1>
                    <h4 className="mb-0">Online Training</h4>
                    <p>
                      We offer most of the course online with virtual classroom
                      to serve the IT aspirants.
                    </p>
                  </div>
                </div>
              </Card>
            </Col>

            <Col md={4} className="mb-2">
              <Card className="shadow feature-cd">
                <div className="d-flex align-items-center teach p-2 rounded-3">
                  {/* <div className="flex-shrink-0">
                  <img src={Mentors} alt="Overall Students" />
                </div> */}
                  <div className="flex-grow-1 ms-2 pt-3 text-center">
                    <h1>
                      <i className="fas fa-project-diagram border rounded-pill bg-hero"></i>
                    </h1>
                    <h4 className="mb-0">Project Training</h4>
                    <p>
                      Project Training Get Trained from anywhere with an
                      Internet connection...
                    </p>
                  </div>
                </div>
              </Card>
            </Col>
            <Col md={4} className="mb-2">
              <Card className="shadow feature-cd">
                <div className="d-flex align-items-center life p-2 rounded-3">
                  {/* <div className="flex-shrink-0">
                  <img src={LifeTime} alt="Overall Students" />
                </div> */}
                  <div className="flex-grow-1 ms-2 pt-3 text-center">
                    <h1>
                      <i className="fas fa-award border rounded-pill bg-hero-l"></i>
                    </h1>
                    <h4 className="mb-0">Lifetime Access</h4>
                    <p>
                      Grow your knowledge and your training and tools with
                      lifetime access.
                    </p>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      {/* <Row className="jobs mx-0 px-5 py-2 bg-warning align-items-center">
        <Col md={4} className="job-lhs">
          <Row className="align-items-center">
            <Col md={3}>
              <img
                src={People}
                alt="People Group"
                className="people img-fluid"
              />
            </Col>
            <Col md={9}>
              <h3>Tools Covered</h3>
              {/* <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Quibusdam.
              </p> */}
      {/* <Button variant="danger" className=" me-4 px-3" size="sm">
                Browse All Categories
              </Button>
            </Col>
          </Row>
        </Col>
        <Col md={6} className="job-rhs">
          <Row>
            <Col className="text-center">
              <i className="fas fa-code fs-1 border-bottom pb-3 px-4"></i>{" "}
              <br />
              <h6 className="pt-2">Developer</h6>
            </Col>
            <Col className="text-center">
              <i className="fas fa-laptop-code fs-1 border-bottom pb-3 px-4"></i>
              <br />
              <h6 className="pt-2">Technology</h6>
            </Col>
            <Col className="text-center">
              <i className="fas fa-chart-bar fs-1 border-bottom pb-3 px-4"></i>
              <br />
              <h6 className="pt-2">Accounting</h6>
            </Col>
            <Col className="text-center">
              <i className="fas fa-graduation-cap fs-1 border-bottom pb-3 px-4"></i>
              <br />
              <h6 className="pt-2">Education & Training</h6>
            </Col>
          </Row>
        </Col>
      </Row> */}
    </>
  );
};

export default Banner;
